import { Type } from '@sinclair/typebox';
import { AgentInteractionRequest } from './interactions.js';
import { AgentSessionSetting } from './session-settings.js';
import { AgentUsage } from './timeline.js';
import { ProtocolVersionSchema } from './version.js';
const NonEmptyString = Type.String({ minLength: 1 });
const Strict = (properties) => Type.Object(properties, { additionalProperties: false });
export const AgentStatus = Type.Union([
    Type.Literal('starting'), Type.Literal('idle'), Type.Literal('running'), Type.Literal('waiting'),
    Type.Literal('failed'), Type.Literal('closed'),
]);
export const AgentCapabilities = Strict({
    history: Type.Boolean(),
    sendMessage: Type.Boolean(),
    queueMessage: Type.Optional(Type.Boolean()),
    steer: Type.Boolean(),
    cancel: Type.Boolean(),
    readResource: Type.Boolean(),
    planning: Type.Optional(Type.Boolean()),
    sessionSettings: Type.Optional(Type.Boolean()),
    commands: Type.Optional(Type.Boolean()),
    interactions: Strict({
        question: Type.Boolean(),
        planApproval: Type.Boolean(),
        toolApproval: Type.Boolean(),
        form: Type.Optional(Type.Boolean()),
        permissionApproval: Type.Optional(Type.Boolean()),
        externalAction: Type.Optional(Type.Boolean()),
    }),
});
export const AgentPersistenceHandle = Strict({
    providerId: NonEmptyString,
    sessionId: NonEmptyString,
    opaque: NonEmptyString,
});
export const AgentPlanningState = Strict({
    active: Type.Boolean(),
    requested: Type.Optional(Type.Boolean()),
});
export const AgentChildSession = Strict({
    nativeSessionId: NonEmptyString,
    title: Type.String(),
    role: Type.Optional(Type.String()),
    description: Type.Optional(Type.String()),
    createdAt: NonEmptyString,
    parentTurnId: Type.Optional(NonEmptyString),
    parentCallId: Type.Optional(NonEmptyString),
    status: AgentStatus,
    observation: Type.Union([Type.Literal('live'), Type.Literal('saved_history')]),
});
export const AgentRuntimeInfo = Strict({
    providerId: NonEmptyString,
    sessionId: Type.Union([NonEmptyString, Type.Null()]),
    status: AgentStatus,
    cwd: Type.Optional(NonEmptyString),
    model: Type.Optional(Type.Union([NonEmptyString, Type.Null()])),
    mode: Type.Optional(Type.Union([NonEmptyString, Type.Null()])),
    planning: Type.Optional(AgentPlanningState),
    settings: Type.Optional(Type.Array(AgentSessionSetting)),
    childSessions: Type.Optional(Type.Array(AgentChildSession)),
    persistence: Type.Optional(AgentPersistenceHandle),
});
export const AgentSnapshotPayload = Strict({
    id: NonEmptyString,
    providerId: NonEmptyString,
    cwd: Type.Optional(NonEmptyString),
    model: Type.Optional(Type.Union([NonEmptyString, Type.Null()])),
    createdAt: NonEmptyString,
    updatedAt: NonEmptyString,
    status: AgentStatus,
    activeTurn: Type.Union([
        Strict({ turnId: NonEmptyString, startedAt: Type.Optional(Type.Union([NonEmptyString, Type.Null()])) }),
        Type.Null(),
    ]),
    capabilities: AgentCapabilities,
    pendingInteractions: Type.Array(AgentInteractionRequest),
    runtimeInfo: AgentRuntimeInfo,
    persistence: Type.Optional(AgentPersistenceHandle),
    lastUsage: Type.Optional(AgentUsage),
    lastError: Type.Optional(Type.String()),
});
export const AgentSnapshot = Strict({
    protocolVersion: ProtocolVersionSchema,
    type: Type.Literal('agent_snapshot'),
    payload: AgentSnapshotPayload,
});
//# sourceMappingURL=snapshot.js.map